import header from "./flurkarte.webp";
import section1 from "./high-angle-view-buildings-city.webp";
import section2 from "./umgebungsplan.webp";
import section3 from "./etagenplan.png";
import section4 from "./umgebungsplan.png";
import section5 from "./aerial-view-residential-buildings.webp";

export { header, section1, section2, section3, section4, section5 };
